import * as React from 'react';
import * as styles from './styles.css';

import { Header1, InlineText1 } from '@cian/ui-kit/typography';

import { Strip, StripItem } from '../../components';
import { IStripItem } from '../../../../types/hero';

export interface IHeroProps {
  stripContent: IStripItem[];
  stripRef?: React.RefObject<HTMLDivElement>;
  onSwipe?(): void;
}

export function Hero({ stripContent, stripRef, onSwipe }: IHeroProps) {
  return (
    <div className={styles['container']}>
      <h1 className={styles['title']}>
        <Header1 color="white_100">Влияние кризиса и самоизоляции на рынок недвижимости</Header1>
      </h1>
      <div className={styles['description']}>
        <InlineText1 color="white_100">
          Каждый день обновляем данные об изменении спроса, предложения и цен на жилье
        </InlineText1>
      </div>
      <Strip stripRef={stripRef} onSwipe={onSwipe}>
        {stripContent.map(({ trend, title, description }, index) => {
          return <StripItem key={index} trend={trend} title={title} description={description} />;
        })}
      </Strip>
    </div>
  );
}
